<template>
    <!-- Configuration modal -->
    <div class="modal fade" id="configureModal" tabindex="-1" ref="configureModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Configuration details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">

                    <h6 v-if="deviceDetail.host_topic">Host topic: <a>{{ deviceDetail.host_topic }}</a></h6>


                    <div class="input-group">
                        <select v-model="config_target" @change="onTargetChange()" class="form-select">
                            <option value="client">Client</option>
                            <option value="acsa" v-if="checkIfTargetIsApplicable('acsa')">ACSA</option>
                            <option value="aboard" v-if="checkIfTargetIsApplicable('aboard')">Aboard</option>
                            <option value="bms" v-if="checkIfTargetIsApplicable('bms')">BMS</option>
                            <option value="inrec" v-if="checkIfTargetIsApplicable('inrec')">InREC</option>
                            <option :value="'inrec_' + index" v-for="index in deviceDetail.inrecs_in_cluster">InREC ({{ index }})</option>
                        </select>
                        <button type="button" class="btn btn-primary" @click="readConfig()" style="margin-right: 10px;">
                            Read
                        </button>
                    </div>
                    <br/>
                    <Vue3JsonEditor
                        v-if="current_config"
                        v-model="current_config"
                        :show-btns="false"
                        :mode="'view'"
                        :expandedOnStart="true"/>
                    <div class="alert alert-warning" role="alert" v-else>
                        Waiting for data...
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['deviceDetail', 'client'],
    setup(props) { },
    data() {
        return {
            config_target: "client",
            current_config: this.deviceDetail.info,
            current_serial: this.deviceDetail.serial,
        };
    },
    watch: { 
        deviceDetail: {
            handler(val) {
                if (this.current_serial != val.serial) {
                    // Reset config target
                    this.config_target = "client";
                    this.current_serial = val.serial;
                }
                this.onTargetChange()
            },
            deep: true
        }
    },
    methods: {
        checkIfTargetIsApplicable(target) {
            return (this.deviceDetail.info && this.deviceDetail.info.devices && this.deviceDetail.info.devices[target]);
        },        
        onTargetChange() {
            if (this.deviceDetail != null) {
                switch (this.config_target) {
                    case 'client':
                        this.current_config = this.deviceDetail.info;
                        break;
                    default:
                        if (this.deviceDetail[this.config_target]) {
                            this.current_config = this.deviceDetail[this.config_target].config;
                        } else {
                            this.current_config = null
                        }
                        break;
                }
            } else {
                this.current_config = null
            }
        },
        readConfig() {
            if (this.deviceDetail != null) {
                var topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
                var payload = {
                    function: "read_config",
                    target: this.config_target,
                }

                // Clear 'cached' data
                switch (this.config_target) {
                    case 'client':
                        this.deviceDetail.info = null
                        break;
                    default:
                        if (this.deviceDetail[this.config_target]) {
                            this.deviceDetail[this.config_target].config = null
                        }
                        break;
                }
                this.current_config = null

                //console.log("Requesting config data update from " + this.config_target + "...")
                //console.log({ topic: topic, payload: payload })
                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }
        },
    },
};
</script>